import React from "react";
import {
  RequiredCheckbox,
  ValidationMessage,
  StepHeader,
} from "../activity-components/FormComponents";
import { StepProps, ActivityFormProps } from "../types";

type Step1ExtraProps = Pick<
  ActivityFormProps,
  | "descriptionOfTab1"
  | "startAcceptCriteriaText"
  | "startSelfCertifiedText"
  | "certificationText"
  | "wantToCertifyText"
  | "dontKnowText"
>;

type Props = StepProps & Step1ExtraProps;

const CERT_OPTIONS = [
  { key: "certificationText", value: "accepted" },
  { key: "wantToCertifyText", value: "want-to-certify" },
  { key: "dontKnowText", value: "dont-know" },
] as const;

export function Step1({
  data,
  setData,
  validationErrors,
  clearValidationError,
  stepFocusRef,
  descriptionOfTab1,
  startAcceptCriteriaText,
  startSelfCertifiedText,
  certificationText,
  wantToCertifyText,
  dontKnowText,
  onBlur,
}: Props) {
  const certLabels = { certificationText, wantToCertifyText, dontKnowText };

  return (
    <>
      <div>
        <StepHeader
          focusRef={stepFocusRef}
          ariaLabel="Steg 1: Certifiering"
          description={descriptionOfTab1}
        />

        {/* Acceptera kriterier */}
        <div>
          <RequiredCheckbox
            id="startAcceptCriteria"
            checked={!!data.startAcceptCriteria}
            onChange={(checked) => {
              setData((s) => ({ ...s, startAcceptCriteria: checked }) as any);
              clearValidationError("startAcceptCriteria");
            }}
            onBlur={onBlur("startAcceptCriteria")}
            hasError={validationErrors.has("startAcceptCriteria")}
            label={startAcceptCriteriaText}
          />
        </div>
      </div>

      {/* Certifieringsstatus */}

      <div className="vgr-form__group">
        <div
          id="certification"
          className={`${validationErrors.has("certificationStatus") ? "vgr-form__group--error" : ""}`}
        >
          <fieldset id="certificationStatus">
            <legend>
              <strong>{startSelfCertifiedText}</strong>
              <span className="ms-1 invalid" aria-hidden="true">
                *
              </span>
            </legend>

            {CERT_OPTIONS.map(({ key, value }) => (
              <label htmlFor={`cert-${value}`} key={value}>
                  <input
                    id={`cert-${value}`}
                    type="radio"
                    name="certification"
                    value={value}
                    checked={data.certificationStatus === value}
                    onChange={(e) => {
                      setData((s) => ({
                        ...s,
                        certificationStatus: e.target.value as any,
                      }));
                      clearValidationError("certificationStatus");
                    }}
                    onBlur={onBlur("certificationStatus")}
                    required
                    aria-invalid={
                      validationErrors.has("certificationStatus") || undefined
                    }
                  />
                  <span className="visually-hidden">Alternativ:</span>
                  {certLabels[key]}
                </label>
            ))}
          </fieldset>
        </div>
        <ValidationMessage
          hasError={validationErrors.has("certificationStatus")}
          message="Fältet är obligatoriskt, välj ett alternativ."
        />
      </div>
    </>
  );
}
